// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/shotlist_service.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { GetShotlistRequestSchema, GetShotlistResponseSchema } from "./get_shotlist_pb";
import { file_vision_shotlist_v1_get_shotlist } from "./get_shotlist_pb";
import type { CreateShotsRequestSchema, CreateShotsResponseSchema } from "./create_shots_pb";
import { file_vision_shotlist_v1_create_shots } from "./create_shots_pb";
import type { UpdateShotRequestSchema, UpdateShotResponseSchema } from "./update_shot_pb";
import { file_vision_shotlist_v1_update_shot } from "./update_shot_pb";
import type { DeleteShotRequestSchema, DeleteShotResponseSchema } from "./delete_shot_pb";
import { file_vision_shotlist_v1_delete_shot } from "./delete_shot_pb";
import type { CreateCastRequestSchema, CreateCastResponseSchema } from "./create_cast_pb";
import { file_vision_shotlist_v1_create_cast } from "./create_cast_pb";
import type { UpdateCastRequestSchema, UpdateCastResponseSchema } from "./update_cast_pb";
import { file_vision_shotlist_v1_update_cast } from "./update_cast_pb";
import type { DeleteCastRequestSchema, DeleteCastResponseSchema } from "./delete_cast_pb";
import { file_vision_shotlist_v1_delete_cast } from "./delete_cast_pb";
import type { CreatePropRequestSchema, CreatePropResponseSchema } from "./create_prop_pb";
import { file_vision_shotlist_v1_create_prop } from "./create_prop_pb";
import type { DeletePropRequestSchema, DeletePropResponseSchema } from "./delete_prop_pb";
import { file_vision_shotlist_v1_delete_prop } from "./delete_prop_pb";
import type { CreateShotlistPresetRequestSchema, CreateShotlistPresetResponseSchema } from "./create_shotlist_preset_pb";
import { file_vision_shotlist_v1_create_shotlist_preset } from "./create_shotlist_preset_pb";
import type { UpdateShotlistConfigRequestSchema, UpdateShotlistConfigResponseSchema } from "./update_shotlist_config_pb";
import { file_vision_shotlist_v1_update_shotlist_config } from "./update_shotlist_config_pb";

/**
 * Describes the file vision/shotlist/v1/shotlist_service.proto.
 */
export const file_vision_shotlist_v1_shotlist_service: GenFile = /*@__PURE__*/
  fileDesc("Cil2aXNpb24vc2hvdGxpc3QvdjEvc2hvdGxpc3Rfc2VydmljZS5wcm90bxIZcHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MTKDCgoOVmlzaW9uU2hvdGxpc3QSbgoLR2V0U2hvdGxpc3QSLS5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkdldFNob3RsaXN0UmVxdWVzdBouLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuR2V0U2hvdGxpc3RSZXNwb25zZSIAEm4KC0NyZWF0ZVNob3RzEi0ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5DcmVhdGVTaG90c1JlcXVlc3QaLi5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkNyZWF0ZVNob3RzUmVzcG9uc2UiABJrCgpVcGRhdGVTaG90EiwucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5VcGRhdGVTaG90UmVxdWVzdBotLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVXBkYXRlU2hvdFJlc3BvbnNlIgASawoKRGVsZXRlU2hvdBIsLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlU2hvdFJlcXVlc3QaLS5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkRlbGV0ZVNob3RSZXNwb25zZSIAEmsKCkNyZWF0ZUNhc3QSLC5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkNyZWF0ZUNhc3RSZXF1ZXN0Gi0ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5DcmVhdGVDYXN0UmVzcG9uc2UiABJrCgpVcGRhdGVDYXN0EiwucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5VcGRhdGVDYXN0UmVxdWVzdBotLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVXBkYXRlQ2FzdFJlc3BvbnNlIgASawoKRGVsZXRlQ2FzdBIsLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlQ2FzdFJlcXVlc3QaLS5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkRlbGV0ZUNhc3RSZXNwb25zZSIAEmsKCkNyZWF0ZVByb3ASLC5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkNyZWF0ZVByb3BSZXF1ZXN0Gi0ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5DcmVhdGVQcm9wUmVzcG9uc2UiABJrCgpEZWxldGVQcm9wEiwucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5EZWxldGVQcm9wUmVxdWVzdBotLnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuRGVsZXRlUHJvcFJlc3BvbnNlIgASiQEKFENyZWF0ZVNob3RsaXN0UHJlc2V0EjYucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5DcmVhdGVTaG90bGlzdFByZXNldFJlcXVlc3QaNy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkNyZWF0ZVNob3RsaXN0UHJlc2V0UmVzcG9uc2UiABKJAQoUVXBkYXRlU2hvdGxpc3RDb25maWcSNi5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlVwZGF0ZVNob3RsaXN0Q29uZmlnUmVxdWVzdBo3LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVXBkYXRlU2hvdGxpc3RDb25maWdSZXNwb25zZSIAYgZwcm90bzM", [file_vision_shotlist_v1_get_shotlist, file_vision_shotlist_v1_create_shots, file_vision_shotlist_v1_update_shot, file_vision_shotlist_v1_delete_shot, file_vision_shotlist_v1_create_cast, file_vision_shotlist_v1_update_cast, file_vision_shotlist_v1_delete_cast, file_vision_shotlist_v1_create_prop, file_vision_shotlist_v1_delete_prop, file_vision_shotlist_v1_create_shotlist_preset, file_vision_shotlist_v1_update_shotlist_config]);

/**
 * @generated from service protos.vision.shotlist.v1.VisionShotlist
 */
export const VisionShotlist: GenService<{
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.GetShotlist
   */
  getShotlist: {
    methodKind: "unary";
    input: typeof GetShotlistRequestSchema;
    output: typeof GetShotlistResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.CreateShots
   */
  createShots: {
    methodKind: "unary";
    input: typeof CreateShotsRequestSchema;
    output: typeof CreateShotsResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.UpdateShot
   */
  updateShot: {
    methodKind: "unary";
    input: typeof UpdateShotRequestSchema;
    output: typeof UpdateShotResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.DeleteShot
   */
  deleteShot: {
    methodKind: "unary";
    input: typeof DeleteShotRequestSchema;
    output: typeof DeleteShotResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.CreateCast
   */
  createCast: {
    methodKind: "unary";
    input: typeof CreateCastRequestSchema;
    output: typeof CreateCastResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.UpdateCast
   */
  updateCast: {
    methodKind: "unary";
    input: typeof UpdateCastRequestSchema;
    output: typeof UpdateCastResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.DeleteCast
   */
  deleteCast: {
    methodKind: "unary";
    input: typeof DeleteCastRequestSchema;
    output: typeof DeleteCastResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.CreateProp
   */
  createProp: {
    methodKind: "unary";
    input: typeof CreatePropRequestSchema;
    output: typeof CreatePropResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.DeleteProp
   */
  deleteProp: {
    methodKind: "unary";
    input: typeof DeletePropRequestSchema;
    output: typeof DeletePropResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.CreateShotlistPreset
   */
  createShotlistPreset: {
    methodKind: "unary";
    input: typeof CreateShotlistPresetRequestSchema;
    output: typeof CreateShotlistPresetResponseSchema;
  },
  /**
   * @generated from rpc protos.vision.shotlist.v1.VisionShotlist.UpdateShotlistConfig
   */
  updateShotlistConfig: {
    methodKind: "unary";
    input: typeof UpdateShotlistConfigRequestSchema;
    output: typeof UpdateShotlistConfigResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vision_shotlist_v1_shotlist_service, 0);

